import React from "react";
import { useSelector } from "react-redux";
import MoneyDisplay from "../../../../components/moneyDisplay/moneyDisplay";
import PercentChanged from "../../../../components/percentChanged/percentChanged";
import { asPercentage } from "../../../../utils/formatters";

const ClosingPercentMonthToDate = () => {
  const { closingPercentMTD, closingMTDLink, closingPercentMTDChange } = useSelector(
    (state) => state.firstRiders.firstTimeRiders?.closing
  );
  const isUserQa = useSelector((state) => state.commonReducer.commonProps.qa);

  return (
    <>
      <MoneyDisplay
        value={asPercentage(closingPercentMTD)}
        currency="%"
        currencyLocation="end"
        url={closingMTDLink}
        disableAnimation={isUserQa}
      />
      <PercentChanged
        changeValue={closingPercentMTDChange}
        toolTip="Percentage change from previous month"
        showBorder
      />
    </>
  );
};

export default ClosingPercentMonthToDate;
